import Vue from "vue";
Vue.component("tag-vue", {
  mounted() { }
});
